<template>
  <HeaderHome :organizer_id="event.organizer.id" :organizer_slug="event.organizer.slug" :image="event.image"/>
  <div class="container-fluid body">
    <div class="container">
      <Loader :show="loading"/>
      <div class="row body-box">
        <div class="col-md-12" ref="lote">
          <h1>{{ event.name }}</h1>
          <h2 v-if="order.user_id"><b>*Compra para outro Usuário TKX</b><br></h2>
          <br>
        </div>

        <form @submit.prevent="submit" ref="form">

          <div class="col-md-12 lotes" v-if="lotes.length > 1 || (lotes.length == 1 && lotes[0].disabled == true)">
            <div class="row">
              <div class="col-xs-12 mb-2">
                <h2> Escolha o Lote desejado:</h2>
                <h4 style="color: red;" > *Caso sua faixa etária não esteja visível isso significa que não há mais vagas na mesma.</h4>
                <br>
              </div>
            </div>
            <div class="row">
              <div :class="['col-md-4','col-sm-6','inscricoes',order.lote_id == lote.id ? 'selected':'']" v-for="(lote,index) in lotes" :key="index">

                <div class="card card-default" @click="select_lote(lote.id,index)" v-if="lote.disabled == false">
                  <div class="card-body text-center">
                    <p>{{ lote.name }}</p>
                  </div>
                </div>

                <div class="card card-default disabled-card disabled" v-if="lote.disabled == true">
                  <div class="card-body text-center">
                    <p style="padding-bottom: 0px">{{ lote.name }}</p>
                    <small style="font-size: 12px;">Sua faixa etária não permite se inscrever nesse lote.</small>
                  </div>
                </div>

              </div>
            </div>
          </div>

          <div class="col-md-12 lotes" v-if="lotes.length == 1 || (lotes.length == 1 && lotes[0].disabled == true)">
            <div class="row">
              <div class="col-xs-12 mb-2">
                <h2>{{lotes[0].name}}</h2>
              </div>
            </div>
          </div>

          <div class="col-md-12 lotes" v-if="lotes.length == 0 && this.loading == false ">
            <div class="row">
              <div class="col-xs-12 mb-2">
                <h2> Escolha o Lote desejado:</h2>
              </div>
            </div>
            <div class="row">
              <div :class="['col-md-12','inscricoes']">
                <div class="card card-default">
                  <div class="card-body text-center">
                    <p>Não existem lotes disponíveis no momento.</p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div :class="['col-md-12','codigo','mb-4',codigo_valid == false ? 'invalido':'']" v-if="lote_index != null && lotes[lote_index].has_codes" ref="codigo">
            <div class="row">
              <div class="col-xs-12 mb-2">
                <h2> {{ lotes[lote_index].text_code != null ? lotes[lote_index].text_code : "Entre com o Codigo para o Lote :" }}</h2>
              </div>
            </div>
            <div class="row">
              <div :class="['col-md-4','col-sm-6','col-xs-8']">
                <input type="text" name="code" v-model="codigo" class="form-control">
              </div>
              <div :class="['col-md-2','col-sm-2','col-xs-2', 'text-center' , 'mt-2']">
                <button class="btn btn-danger" @click.prevent="valida_code">Validar</button>
              </div>
            </div>
          </div>

          
          <div :class="['col-md-12','codigo','mb-4',codigo_valid == false ? 'invalido':'']" v-if="lote_index != null && lotes[lote_index].is_mandatory" ref="observation">
            <div class="row">
              <div class="col-xs-12 mb-2">
                <h2> {{ lotes[lote_index].observation != null ? lotes[lote_index].observation : "Observação:" }}</h2>
              </div>
            </div>
            <div class="row">
              <div :class="['col-md-4','col-sm-6','col-xs-8']">
                <input type="text" name="code" v-model="observation" class="form-control">
              </div>
              <div :class="['col-md-2','col-sm-2','col-xs-2', 'text-center' , 'mt-2']">
                <button class="btn btn-danger" @click.prevent="save_obs">Continuar</button>
              </div>
            </div>
          </div>


          <div class="col-md-12 categoria" v-show="categorias.length && show_categorias" ref="categorias">
            <div class="row">
              <div class="col-xs-12 mb-2">
                <h2> Escolha a Categoria desejada:</h2>
              </div>
            </div>
            <div class="row">
              <div :class="['col-md-4','col-sm-6','inscricoes',order.modality_id == categoria.id ? 'selected':'']" v-for="(categoria,index) in categorias" :key="index">
                <div class="card card-default" @click="select_categoria(categoria.id)">
                  <div class="card-body text-center">
                    <p>{{ categoria.categoria }} - {{ categoria.name }}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="col-md-12 kits" v-show="kits.length && show_kits" ref="kits">
            <div class="row">
              <div class="col-xs-12 mb-2">
                <h2> Escolha o KIT desejado:</h2>
              </div>
            </div>
            <div class="row">
              <div :class="['col-md-4','col-sm-6','inscricoes',order.kit_id == kit.id ? 'selected':'']" v-for="(kit,index) in kits" :key="index">
                <div class="card card-default" @click="select_kit(kit.id,index)">
                  <img class="card-img-top img-card-kit" :src="kit.image" :alt="kit.name">
                  <div class="card-body text-center">
                    <p>{{ kit.name }} - <span>R$ {{ new Intl.NumberFormat('pt-BR', {minimumFractionDigits: 2}).format(kit.price) }}</span></p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="col-md-12 kits" v-show="kits_tamanhos.length" ref="kits_tamanhos">
            <div class="row">
              <div class="col-xs-12 mb-2">
                <h2> Escolha a o Tamanho:</h2>
              </div>
            </div>
            <div class="row">
              <div :class="['col-md-4','col-sm-6','inscricoes',order.tamanho == kit_tamanho ? 'selected':'']" v-for="(kit_tamanho,index) in kits_tamanhos" :key="index">
                <div class="card card-default" @click="select_tamanho(kit_tamanho)">
                  <div class="card-body text-center">
                    <p>{{ kit_tamanho }}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="col-md-12 agendamentos" v-show="agendamentos.length && show_agendamento" ref="agendamentos">
            <div class="row">
              <div class="col-xs-12 mb-2">
                <h2> Escolha a Hora da Retirada do Kit:</h2>
              </div>
            </div>
            <div class="row">
              <div :class="['col-md-4','col-sm-6','inscricoes',order.schedule_id == agendamento.id ? 'selected':'']" v-for="(agendamento,index) in agendamentos" :key="index">
                <div class="card card-default" @click="select_agendamento(agendamento)">
                  <div class="card-body text-center">
                    <p>{{ agendamento.description }}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>


          <div class="col-md-12 mt-4 mb-4 final" ref="final" v-show="end_selections && ((agendamentos.length == 0 && order.schedule_id == null) || (agendamentos.length != 0 && order.schedule_id != null)) ">
            <div class="row">
              <div class="col-md-6">
                <label>
                  <input type="checkbox" v-model="order.termos" required>
                  Declaro que li e aceito o <a href="#regulamento" @click.prevent="show_regulamentos">regulamento</a>.
                </label>
              </div>
              <div class="col-md-6 text-right">
                <button class="btn btn-primary">PRÓXIMO PASSO</button>
              </div>
            </div>
          </div>

        </form>

        <div class="modal fade in regulamentos" tabindex="-1" role="dialog" style="display: block;" v-if="modalregulation" @click="modalregulation= false">
          <div class="modal-dialog  modal-lg" role="document">
            <div class="modal-content" @click.stop="">
              <div class="modal-header text-center">
                <button type="button" class="close" @click="modalregulation= false" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                <h4 class="modal-title">Regulamento</h4>
              </div>
              <div class="modal-body" v-html="regulation">
              </div>
            </div><!-- /.modal-content -->
          </div><!-- /.modal-dialog -->
        </div><!-- /.modal -->
        <div class="modal-backdrop fade in" v-if="modalregulation"></div>


        <Atalhos/>
      </div>
    </div>
  </div>

  <Newsletter/>
  <Footer/>
  <FooterEnd/>
</template>

<script>
import {defineComponent} from "vue";
import HeaderHome from "../components/HeaderHome";
import Footer from "../components/Footer.vue";
import FooterEnd from "../components/FooterEnd.vue";
import Newsletter from "../components/Newsletter.vue";
import Atalhos from "@/components/Atalhos";
import Events from "@/api/Events";
import Loader from "../components/Loader";
import Auth from "@/api/Auth";
import Carrinho from "@/api/Carrinho";
import Orders from "../api/Orders";
import Swal from "sweetalert2";
import User from "../api/User";

export default defineComponent({
  name: "EscolhaKitRestritoPage",
  components: {
    HeaderHome,
    Footer,
    FooterEnd,
    Newsletter,
    Atalhos,
    Loader,
  },
  computed: {
    modalidades: function () {
      let modalidades = "";
      this.event.modalities.map((item) => {
        modalidades = item.name + ', ' + modalidades;
      })
      return modalidades;
    }
  },
  data() {
    return {
      modalregulation: false,
      end_selections: false,
      regulation: "",
      id: '',
      slug: '',
      lote: '',
      hash: '',
      loading: true,
      event: {
        "id": 0,
        "subscription_end": "",
        "largada": "",
        "name": "",
        "slug": "",
        "local": "",
        "state": "",
        "city": "",
        "description": "",
        "kits": "",
        "course": "",
        "awards": "",
        "complementary": "",
        "organizer": {
          "id": 0,
          "razao_social": "",
          "slug": "",
          "cnpj": "",
          "telephone": ""
        },
        "modalities": [],
        "banners": [],
        "sponsor": [],
      },
      'user_age':0,
      'codigo': '',
      'observation':"",
      "codigo_valid": true,
      "categorias": [],
      "agendamentos": [],
      "lotes": [],
      'lote_index': null,
      "kits": [],
      "kits_tamanhos": [],
      "show_kits": false,
      "show_agendamento": false,
      "show_categorias":false,
      "need_agendamento":false,
      "order": {
        'schedule_id':null,
        'event_id': null,
        "lote_id": null,
        "modality_id": null,
        "kit_id": null,
        "codigo": '',
        "tamanho": null,
        "termos": false,
      },
    };
  },
  methods: {
    submit() {
      this.$refs.form.reportValidity();

      let itens_carrinho = Carrinho.get_itens();
      let result = itens_carrinho.filter((item)=>{
        if(item.event_id == this.order.event_id){
          if(this.order.user_id === item.user_id){
            return true;
          }else{
            return false;
          }
        }else{
            return false;
        }
      });

      if(result.length){
        Swal.fire({
          icon: 'error',
          title:'Você já possui esse evento em seu carrinho.',
          showConfirmButton: true,
        });
        return false;
      }
      this.loading = true;

      Carrinho.add_last_event(this.id,this.slug);
      Carrinho.add_item(this.order);
      if(window.localStorage.getItem('user_buy')){
         window.localStorage.removeItem('user_buy')
      }

      setTimeout(() => {
        window.scrollTo(0, 0);
        this.$router.push('/carrinho/');
      }, 500);
    },
    show_regulamentos() {
      if (this.regulation == "") {
        Events.get_regulamento(this.slug).then((request) => {
          if (request.status == 200) {
            this.modalregulation = true;
            this.regulation = request.data.regulation;
          }
        });
      } else {
        this.modalregulation = true;
      }

    },
    select_agendamento(agendamento){
      this.order.schedule_id = agendamento.id;

      this.goto_scroll(this.$refs.final);
    },
    status(event) {
      let today = new Date();
      let start_date = new Date(event.subscription_start);
      let end_date = new Date(event.subscription_end);
      if (start_date <= today && end_date >= today) {
        return true;
      } else {
        return false;
      }
    },
    goto_scroll(element) {
      setTimeout(() => {
        this.$smoothScroll({
          offset: -100,
          scrollTo: element,
        });
      }, 500);
    },
    select_categoria(id) {

      this.order.termos = false;
      this.end_selections = false;
      this.order.tamanho = null;
      this.order.kit_id = null;
      this.show_kits = true;

      this.order.modality_id = id;
      this.goto_scroll(this.$refs.kits);
    },
    select_tamanho(tamanho) {
      this.order.termos = false;
      this.order.tamanho = tamanho;
      this.end_selections = true;
      this.show_agendamento = true;
      if(this.agendamentos.length){
        this.goto_scroll(this.$refs.agendamentos);
      }else{
        this.goto_scroll(this.$refs.final);
      }
    },
    select_lote(id, index) {

      this.lote_index = index;
      this.order.lote_id = id;

      this.codigo = "";

      this.show_kits = false;
      this.show_agendamento = false;
      this.codigo_valid = true;
      this.order.termos = false;
      this.end_selections = false;
      this.categorias = [];
      this.kits = [];
      this.order.kit_id = null;
      this.order.modality_id = null;

      this.order.tamanho = null;
      this.kits_tamanhos = [];

      
      if(this.lotes[index].is_observation && this.lotes[index].is_mandatory){
        //
      }else if (this.lotes[index] && (this.lotes[index].has_codes == false)) {
        Events.get_categorias(this.order.event_id, Auth.token()).then((request) => {
          if (request.status == 200) {
            this.categorias = request.data;
            this.show_categorias = true;
            this.goto_scroll(this.$refs.categorias);
          }
        });
        Events.get_kits(this.order.lote_id, Auth.token()).then((request) => {
          if (request.status == 200) {
            this.kits = request.data;
          }
        });
      }
    },
    save_obs(){
      Events.get_categorias(this.order.event_id, Auth.token()).then((request) => {
          if (request.status == 200) {
            this.categorias = request.data;
            this.show_categorias = true;
            this.goto_scroll(this.$refs.categorias);
          }
      });
      Events.get_kits(this.order.lote_id, Auth.token()).then((request) => {
        if (request.status == 200) {
          this.kits = request.data;
        }
      });
    },
    valida_code() {
      let Maratona = 438;
      let maratona_ref = 27;
      let Meia =441;
      let meia_ref = 28;
      let k12 = 442;
      let k12_ref = 29;

      Orders.validate_code(this.order.lote_id, this.codigo, Auth.token()).then((request) => {
        this.order.termos = false;
        this.end_selections = false;
        this.categorias = [];
        this.kits = [];
        this.order.kit_id = null;
        this.order.modality_id = null;

        this.order.tamanho = null;

        this.show_kits = false;
        this.show_agendamento = false;

        this.kits_tamanhos = [];


        if (request.status == 200 && request.data && request.data.status === true) {

          let carrinho = Carrinho.get_itens();
          let codigos_carrinho = carrinho.filter(item => item.codigo == this.codigo);


          if(request.data.quantity <= codigos_carrinho.length){
            this.codigo_valid = false;
            this.codigo = "";

            Swal.fire({
              icon: 'error',
              title:'Este código já está sendo utilizado em outro item no carrinho.',
              showConfirmButton: true,
            });

          }else{
            this.codigo_valid = true;
            this.order.codigo = this.codigo;

            Events.get_categorias(this.order.event_id, Auth.token()).then((request) => {
              if (request.status == 200) {
                this.categorias = request.data;

                if(this.order.lote_id == Maratona){
                  this.order.modality_id = maratona_ref;
                  this.show_kits = true;
                  this.goto_scroll(this.$refs.kits);
                }else if(this.order.lote_id == Meia){
                  this.order.modality_id = meia_ref;
                  this.show_kits = true;
                  this.goto_scroll(this.$refs.kits);
                }else if(this.order.lote_id == k12){
                  this.order.modality_id = k12_ref;
                  this.show_kits = true;
                  this.goto_scroll(this.$refs.kits);
                }else{

                  this.show_categorias = true;
                  this.goto_scroll(this.$refs.categorias);
                }


              }
            });
            Events.get_kits(this.order.lote_id, Auth.token()).then((request) => {
              if (request.status == 200) {
                this.kits = request.data;
              }
            });

          }


        } else {
          this.codigo_valid = false;
          this.codigo = "";

          Swal.fire({
            icon: 'error',
            title:'Código de validação não é valido.',
            showConfirmButton: true,
          });

        }
      });

    },
    select_kit(id, index) {

      this.order.termos = false;
      this.end_selections = false;
      this.order.tamanho = null;
      this.kits_tamanhos = [];

      this.order.kit_id = id;
      this.kits_tamanhos = (this.kits[index].options).split(',');

      this.goto_scroll(this.$refs.kits_tamanhos);

    },
    to_other_user(){
      Swal.fire({
        title: 'Entre com o E-mail do outro Usuário.',
        input: 'email',
        inputAttributes: {
          autocapitalize: 'off'
        },
        showCancelButton: true,
        confirmButtonText: 'Ir para compra',
        cancelButtonText:'Cancelar',
        showLoaderOnConfirm: true,
        allowOutsideClick:false,
        preConfirm: (login) => {
          return User.get_userid(login,Auth.token())
              .then(response => {
                if (!response.status == 200) {
                  throw new Error(response.statusText)
                }
                return response.data
              })
              .catch(error => {
                Swal.showValidationMessage(
                    `Request failed: ${error}`
                )
              })
        },
      }).then((result) => {
        if (result.isConfirmed) {
          if(result.value.id){
            this.order.user_id =result.value.id;
            this.order.birthday =result.value.birthday;
            this.user_age = this.get_age(this.order.birthday);

            this.verify_user();
          }else{
            Swal.fire({
              title: `Usuário não foi encontrado em nossa base de dados.`,
            }).then(()=>{
              this.to_other_user();
            });
          }
        }else if (result.isDismissed) {
              window.scrollTo(0, 0);
              this.$router.push('/minha-conta/');
        }
      })
    },
    verify_user(){
      let user_id = Auth.user().id;

      if( typeof this.order.user_id != "undefined"){
        user_id = this.order.user_id;
      }

      User.get_user_event(this.id,user_id,Auth.token()).then((request)=>{
        if(request.status == 200 && request.data == true){
          Swal.fire({
            title: 'Este Usuário já possui uma inscrição para este evento.',
            text:'Deseja comprar está inscrição para outro usuário ?',
            showDenyButton: false,
            showCancelButton: true,
            confirmButtonText: `SIM`,
            cancelButtonText:'NÃO'
          }).then((result) => {
            /* Read more about isConfirmed, isDenied below */
            if (result.isConfirmed) {
              this.to_other_user();
            } else if (result.isDismissed) {
              window.scrollTo(0, 0);
              this.$router.push('/minha-conta/');
            }
          })
        }else{
          this.validate_age(this.lotes);
          this.lotes.map((a,b) => {
            if(a.disabled == false){
                this.select_lote(a.id, b);
            }
          })
        }
      });
    },
    erro_agendamento(){
      Swal.fire({
        title: 'No momento não ha agendamentos disponíveis para esse evento.',
        text:'Para mais informações ou duvidas entre em contacto com nosso suporte.',
        showDenyButton: false,
        showCancelButton: false,
        confirmButtonText: `OK`,
        cancelButtonText:'NÃO'
      }).then(() => {
          window.scrollTo(0, 0);
          this.$router.push('/minha-conta/');
      });
    },
    validate_age(lote) {
      let temp = [];
      lote.map((value) => {
        if(value.age_max  >= this.user_age && value.age_min <= this.user_age){
          value.disabled = false;
        }else{
          value.disabled = true;
        }
        temp.push(value);
      });
      return temp;
    },
    get_age(birthday){
      let nwbirthday =  birthday.replaceAll('.000000Z','');
     // nwbirthday =  nwbirthday.replaceAll('T',' ');
      let age  = new Date() - new Date(nwbirthday);

      return  Math.floor((age / (1000 * 3600 * 24) )  / 365);
    },
    fetch_info() {

      if(window.localStorage.getItem('user_buy')){
        this.order.user_id = window.localStorage.getItem('user_buy');

        window.localStorage.removeItem('user_buy')
      }

      let User = Auth.user();
      this.user_age = this.get_age(User.birthday);

      this.order.event_id = null;
      this.lote_index = null;
      this.lotes = [];

      this.show_agendamento = false;

      Events.get_event(this.slug).then((request) => {
        if (request.status == 200) {
          this.event = request.data;

          this.order.event_id = this.event.id;
        } else {
          this.$router.push("/evento/nao-encontrado/");
        }

        Events.get_lotes(this.id, 2, Auth.token()).then((request) => {

          if (request.status == 200) {
            let resp = [] ;

            request.data.map((item) => {
              if(item.id == this.lote){
                item.disabled = false;
                resp.push(item);
              }
            });

            this.lotes = this.lotes.concat(resp);
            this.lotes = this.validate_age(this.lotes);

            this.lotes.map((a,b)=>{
              if(a.id == this.lote){
                this.select_lote(a.id, b)
              }
            });
          }
        });

        Events.get_lotes(this.id, 3, Auth.token()).then((request) => {
          if (request.status == 200) {
              let resp = [] ;
              request.data.map((item) => {
                if(item.id == this.lote){
                  item.disabled = false;
                  resp.push(item);
                }
              });

            this.lotes = this.lotes.concat(resp);
            this.lotes = this.validate_age(this.lotes);

            this.lotes.map((a,b)=>{
              if(a.id == this.lote){
                this.select_lote(a.id, b)
              }
            });

          }
        });


        Events.get_agendamentos(this.id,Auth.token()).then((request) => {
          if (request.status == 200) {
            this.agendamentos = request.data.agendamentos;
            this.need_agendamento = request.data.required;

            if(this.agendamentos.length == 0 && this.need_agendamento == true){
                this.erro_agendamento();
            }
          }
        });

        this.verify_user();


        this.loading = false;
        this.order.termos = false;
        this.end_selections = false;
      });
    },
  },
  mounted() {

    this.order.termos = false;
    this.id = this.$route.params.id;
    this.slug = this.$route.params.slug;
    this.lote = this.$route.params.lote;

    if (this.lote){
      this.lote = atob(this.lote)
    }


    let MD5 = function(d){var r = M(V(Y(X(d),8*d.length)));return r.toLowerCase()};function M(d){for(var _,m="0123456789ABCDEF",f="",r=0;r<d.length;r++)_=d.charCodeAt(r),f+=m.charAt(_>>>4&15)+m.charAt(15&_);return f}function X(d){for(var _=Array(d.length>>2),m=0;m<_.length;m++)_[m]=0;for(m=0;m<8*d.length;m+=8)_[m>>5]|=(255&d.charCodeAt(m/8))<<m%32;return _}function V(d){for(var _="",m=0;m<32*d.length;m+=8)_+=String.fromCharCode(d[m>>5]>>>m%32&255);return _}function Y(d,_){d[_>>5]|=128<<_%32,d[14+(_+64>>>9<<4)]=_;for(var m=1732584193,f=-271733879,r=-1732584194,i=271733878,n=0;n<d.length;n+=16){var h=m,t=f,g=r,e=i;f=md5_ii(f=md5_ii(f=md5_ii(f=md5_ii(f=md5_hh(f=md5_hh(f=md5_hh(f=md5_hh(f=md5_gg(f=md5_gg(f=md5_gg(f=md5_gg(f=md5_ff(f=md5_ff(f=md5_ff(f=md5_ff(f,r=md5_ff(r,i=md5_ff(i,m=md5_ff(m,f,r,i,d[n+0],7,-680876936),f,r,d[n+1],12,-389564586),m,f,d[n+2],17,606105819),i,m,d[n+3],22,-1044525330),r=md5_ff(r,i=md5_ff(i,m=md5_ff(m,f,r,i,d[n+4],7,-176418897),f,r,d[n+5],12,1200080426),m,f,d[n+6],17,-1473231341),i,m,d[n+7],22,-45705983),r=md5_ff(r,i=md5_ff(i,m=md5_ff(m,f,r,i,d[n+8],7,1770035416),f,r,d[n+9],12,-1958414417),m,f,d[n+10],17,-42063),i,m,d[n+11],22,-1990404162),r=md5_ff(r,i=md5_ff(i,m=md5_ff(m,f,r,i,d[n+12],7,1804603682),f,r,d[n+13],12,-40341101),m,f,d[n+14],17,-1502002290),i,m,d[n+15],22,1236535329),r=md5_gg(r,i=md5_gg(i,m=md5_gg(m,f,r,i,d[n+1],5,-165796510),f,r,d[n+6],9,-1069501632),m,f,d[n+11],14,643717713),i,m,d[n+0],20,-373897302),r=md5_gg(r,i=md5_gg(i,m=md5_gg(m,f,r,i,d[n+5],5,-701558691),f,r,d[n+10],9,38016083),m,f,d[n+15],14,-660478335),i,m,d[n+4],20,-405537848),r=md5_gg(r,i=md5_gg(i,m=md5_gg(m,f,r,i,d[n+9],5,568446438),f,r,d[n+14],9,-1019803690),m,f,d[n+3],14,-187363961),i,m,d[n+8],20,1163531501),r=md5_gg(r,i=md5_gg(i,m=md5_gg(m,f,r,i,d[n+13],5,-1444681467),f,r,d[n+2],9,-51403784),m,f,d[n+7],14,1735328473),i,m,d[n+12],20,-1926607734),r=md5_hh(r,i=md5_hh(i,m=md5_hh(m,f,r,i,d[n+5],4,-378558),f,r,d[n+8],11,-2022574463),m,f,d[n+11],16,1839030562),i,m,d[n+14],23,-35309556),r=md5_hh(r,i=md5_hh(i,m=md5_hh(m,f,r,i,d[n+1],4,-1530992060),f,r,d[n+4],11,1272893353),m,f,d[n+7],16,-155497632),i,m,d[n+10],23,-1094730640),r=md5_hh(r,i=md5_hh(i,m=md5_hh(m,f,r,i,d[n+13],4,681279174),f,r,d[n+0],11,-358537222),m,f,d[n+3],16,-722521979),i,m,d[n+6],23,76029189),r=md5_hh(r,i=md5_hh(i,m=md5_hh(m,f,r,i,d[n+9],4,-640364487),f,r,d[n+12],11,-421815835),m,f,d[n+15],16,530742520),i,m,d[n+2],23,-995338651),r=md5_ii(r,i=md5_ii(i,m=md5_ii(m,f,r,i,d[n+0],6,-198630844),f,r,d[n+7],10,1126891415),m,f,d[n+14],15,-1416354905),i,m,d[n+5],21,-57434055),r=md5_ii(r,i=md5_ii(i,m=md5_ii(m,f,r,i,d[n+12],6,1700485571),f,r,d[n+3],10,-1894986606),m,f,d[n+10],15,-1051523),i,m,d[n+1],21,-2054922799),r=md5_ii(r,i=md5_ii(i,m=md5_ii(m,f,r,i,d[n+8],6,1873313359),f,r,d[n+15],10,-30611744),m,f,d[n+6],15,-1560198380),i,m,d[n+13],21,1309151649),r=md5_ii(r,i=md5_ii(i,m=md5_ii(m,f,r,i,d[n+4],6,-145523070),f,r,d[n+11],10,-1120210379),m,f,d[n+2],15,718787259),i,m,d[n+9],21,-343485551),m=safe_add(m,h),f=safe_add(f,t),r=safe_add(r,g),i=safe_add(i,e)}return Array(m,f,r,i)}function md5_cmn(d,_,m,f,r,i){return safe_add(bit_rol(safe_add(safe_add(_,d),safe_add(f,i)),r),m)}function md5_ff(d,_,m,f,r,i,n){return md5_cmn(_&m|~_&f,d,_,r,i,n)}function md5_gg(d,_,m,f,r,i,n){return md5_cmn(_&f|m&~f,d,_,r,i,n)}function md5_hh(d,_,m,f,r,i,n){return md5_cmn(_^m^f,d,_,r,i,n)}function md5_ii(d,_,m,f,r,i,n){return md5_cmn(m^(_|~f),d,_,r,i,n)}function safe_add(d,_){var m=(65535&d)+(65535&_);return(d>>16)+(_>>16)+(m>>16)<<16|65535&m}function bit_rol(d,_){return d<<_|d>>>32-_}

    let hash = MD5(this.id + this.slug)
    if(hash.slice(-8) == this.$route.params.hash){
      console.log('HASH VALIDADA');
    }else{
      this.$router.push("/evento/nao-encontrado/");
    }


    this.hash = this.$route.params.hash;

    window.scrollTo(0, 0);

    this.loading = true;

    this.fetch_info();
  },
  updated() {
    if (this.slug != this.$route.params.slug) {
      this.slug = this.$route.params.slug;
      this.loading = true;
      this.fetch_info();
    }
  }
});
</script>

<style scoped>
img.img-card-kit{
  max-width: 100%;
}
img.capa-evento-view {
  width: 100%;
}

.box-patrocinadores a {
  width: 100%;
}

.box-patrocinadores a img {
  width: 100%;
}

.modal-body {
  max-height: calc(100vh - 210px);
  overflow-y: auto;
}

.mb-4 {
  margin-bottom: 30px;
}

.mb-2 {
  margin-bottom: 15px;
}


.inscricoes.selected .card {
  background-color: #d31f28;
  color: #fff;
  transition: background-color 1s ease;
}

.inscricoes .card p {
  font-size: 20px;
}

.inscricoes .card {
  cursor: pointer;
}

.card .card-img-top {
  width: 100%;
}

.card .card-header {
  background-color: transparent;
  color: #fff;
  text-align: center;

  margin-bottom: -1px;
}

.card {
  border-radius: 7px;
}

.kits, .categoria, .final {
  animation: fade_in_show 1s
}

.card {
  transition: all .2s ease-in-out;
}

.card:hover {
  transform: scale(1.05);
  cursor: pointer;
}

.invalido input.form-control {
  border-color: #d31f28;
}

.btn-danger {
  color: #fff;
  background-color: #d31f28;
  border-color: #d31f28;
}

.card.card-default.disabled-card.disabled {
  background: #e7e7e7;
  cursor: default;
  pointer-events: none;
}

@keyframes fade_in_show {
  0% {
    opacity: 0;
  }

  100% {
    opacity: 1;
  }
}


</style>
